<template>
  <div id="projects">
    <div class="select-wrapper">
      <select v-model="selectedType">
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.label }}
        </option>▾
      </select>
    </div>
    <div class="project-grid">
      <router-link v-for="(project, index) in filteredProjects" :key="index" class="project-container"
        :to="{ name: 'PopUp', params: { projName: `${project.path}` } }" @click.native="$scrollToTop">
        <div class="project-img" :style="{ backgroundImage: `url(&quot;${project.image}&quot;)` }"> </div>
        <div class="proj-content">
          <div class="proj-type">{{ project.type }}</div>
          <div class="proj-text">
            <div class="title">
              <h1>{{ project.title }}</h1><h3>({{ project.year }})</h3>
            </div>
            <div class="by">{{ project.by }}</div>
            <div class="meine-rolle">
              <hl>&#10551;</hl>{{ project.myroll }}
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <pop-up :TogglePopup="() => togglePopup('buttonTrigger')" v-if="popupTrigger.buttonTrigger">
      <h1> </h1>
    </pop-up>
  </div>
</template>

<script>
import { ref } from "vue";
import PopUp from "./PopUp.vue";
export default {
  title: "Jouns - Projekte",
  name: "ProjectsVue",
  components: { PopUp },
  setup() {
    const popupTrigger = ref({
      buttonTrigger: false,
    });
    const togglePopup = (trigger) => {
      popupTrigger.value[trigger] = !popupTrigger.value[trigger];
    };
    return {
      PopUp,
      popupTrigger,
      togglePopup,
    };
  },

  created() {
    this.$store.dispatch('initProjects');
    this.localSelectedType = this.selectedType; // sync Anfangswert
  },
  computed: {
    projects() {
      return this.$store.getters.filteredProjects;
    },
    selectedType: {
      get() {
        return this.$store.state.selectedType;
      },
      set(value) {
        console.log("SET SELECTED TYPE:", value); // ← wichtig!
        this.$store.commit('setSelectedType', value);
      }
    },
    filteredProjects() {
      return this.$store.getters.filteredProjects;
    },
  },
  methods: {
    setFilter(type) {
      this.$store.dispatch('updateSelectedType', type);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    onFilterChange(value) {
      // Da v-model mit computed setter verbunden ist, kannst du das hier optional lassen
      this.selectedType = value;
    },
  },
  data() {
    return {
      localSelectedType: 'Alle', // ← verwalte hier lokal!
      options: [
        { label: 'Alle Projekte', value: 'Alle' },
        { label: 'Fiktional', value: 'Fiktional' },
        { label: 'Musikvideos', value: 'Musikvideo' },
        { label: 'Dokumentarisch', value: 'Dokumentarisch' },
      ],
    };
  },
  watch: {
    localSelectedType(newVal) {
      const selectedValue = newVal?.value || 'Alle';
      this.$store.commit('setSelectedType', selectedValue);
    }
  }
};
</script>

<style lang="scss">
#projects {
  z-index: 1;

  .select-wrapper {
    z-index: 1;
    position: fixed;
    display: flex;
    align-self: end;
    right: 5rem;
    bottom: 3rem;

    &::after {
      content: '▾';
      color: #ffffff;
      position: absolute;
      right: 1rem;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
    }

    &:hover {
      color: #ffee00;
    }

    select {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-color: transparent;
      border: none #ffee00;
      padding: 1rem 2.5rem 1rem 1rem;
      font-size: 0.8rem;
      letter-spacing: 0.05rem;
      text-transform: uppercase;
      color: #ffffff;
      cursor: pointer;
      outline: none;
      position: relative;
      transition: 0.2s;
      background-color: #14141472;

      &:hover {
        background-color: #141414;
        &::after {
          color: #ffffff;
        }
      }

      &:focus {
        border-color: none;
        /* Tailwind's blue-500 */
      }
    }
  }

  .project-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: max-content;
    padding: 0px;
    margin-top: 8vh;

    .project-container {
      grid-column: minmax(1, 3);
      display: flex;
      flex-direction: row;
      background: transparent;
      justify-content: space-between;
      width: 100%;
      height: calc(50vw / 1.77);
      text-decoration: none;
      overflow: hidden;

      /* &:nth-child(2n + 2) {
        background-color: #eeeeee;
      }*/
      &:focus-visible {
        outline: solid 1px;
      }

      &:hover,
      &:active {
        .project-img {
          filter: saturate(1);
          scale: 1.005;
        }
      }
    }

    ::-webkit-scrollbar {
      width: 0px;
      display: none;
    }

    .project-img {
      width: 100%;
      height: calc(50vw / 1.5);
      background-size: cover;
      background-position: center;
      filter: saturate(0);
      transition: 0.3s;
      justify-content: center;
    }

    .proj-content {
      width: 50%;
      height: calc(50vw / 1.77);
      display: flex;
      flex-direction: column;
      position: absolute;
      background-image: linear-gradient(to right,
          rgba(0, 0, 0, 0.5),
          transparent);

      .proj-type {
        margin-left: 4vw;
        margin-top: 4vw;
        width: max-content;
        padding: 0.3rem 0.5rem;
        letter-spacing: 0.05rem;
        border: white solid 0.05rem;
        opacity: 0.5;

      }

      .proj-text {
        height: calc(50vw / 1.77);
        width: 100%;
        display: flex;
        position: absolute;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        padding-left: 4vw;

        .meine-rolle {
          color: white;
          margin: 2rem 0 4rem 0rem;
          opacity: 0.6;

          hl {
            color: #ffee00;
            padding-right: 0.4rem;
            opacity: 1;
          }
        }

        .by {
          display: flex;
          align-items: baseline;
          padding-top: 0.8rem;
          margin: 0 0 0 2rem;

          p {
            padding-right: 0.2rem;
            margin-top: 0.5rem;
            font-size: 1.3rem;
            justify-content: left;
            opacity: 0.5;
            margin-right: 2rem;
          }
        }

        .title {
          display: flex;
          align-items: baseline;
          margin-top: 10rem;
          margin-bottom: 1rem;

          h1 {
            color: #f5f4f3;
            font-size: 2.5vw;
            margin: 0;
          }
          h3{
            font-size: 1vw;
            padding-left: 0.5vw;
            margin: 0;
          }
        }

        table {
          width: 90%;
          font-size: 1rem;
          color: #f5f4f3;

          .roll-title {
            width: 11rem;
          }

          tr {
            vertical-align: top;
          }
        }

        .watchButton {
          font-weight: 500;
          padding-top: 3rem;

          svg {
            width: 1rem;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  #projects {
    .select-wrapper {
      bottom: 5vh;
      right: 1vw;

      &::after {
        right: 1.8rem;
      }

      select {
        padding: 1rem 2rem 1rem 1rem;
        font-size: 1rem;
        scale: 0.8;
      }
    }

    .project-grid {
      margin-top: 12vh;
      grid-template-columns: repeat(1, 1fr);
      grid-gap: 0;

      .project-container {
        height: calc(100vw / 1.77);

        .project-img {
          height: calc(100vw / 1.77);
        }

        .proj-content {
          height: 100%;

          .proj-type {
            display: none;
            font-size: 0.8rem;
            padding: 0.05rem 0.4rem;
            margin-left: 4vw;
            margin-top: 8vw;

          }

        }

        .proj-text {
          height: calc(100vw / 1.77);
          width: 90vw;
          .title{
          h1 {
            font-size: 4vw;
            margin-top: 8vw;
          }
          h3{
            font-size: 2vw;
          }
        }

          .meine-rolle {
            font-size: 0.6rem;
            padding-top: 0.1rem;
            padding-bottom: 13vh;
            margin: 1em;
          }

          .by {
            padding: 0;
            margin-left: 1rem;
            font-size: 0.6rem;
            display: none;
          }

          tr {
            display: none;
          }

          .watchButton {
            padding: 0;
            margin: 5vw 0 5vw 0;
          }
        }
      }
    }
  }
}
</style>
